import React, {useContext} from 'react';
import { Link } from "react-router-dom";
import { LanguageContext } from "../languages/LanguageContext";

const ImportantNews = () => {
    const { language, translations } = useContext(LanguageContext);
    return (
        <>
            <div className='important-container max-w flex jc-sb gap-2 w-full'>
                <div className='content-container flex gap-sm w-full jc-sb wrap'>
                    <div className='flex wrap gap-sm'>
                        <div className='wrapper'>
                            <p>Erasmus+</p>
                            <h3 dangerouslySetInnerHTML={{ __html: translations[language]["importantTitle1"]}}></h3>
                            {translations[language]["sendEmail"]} <Link to='mailto:aldona.biedermann@gmail.com'><b>aldona.biedermann@gmail.com</b></Link>
                            <br/>
                            Mobile tel.: +43 699 120 35834 or +43 676 403 6013<br/>
                            Messenger: Aldona Biedermann
                        </div>
                    </div>
                    <div className='image-container'>
                        <video src='/videos/mokymai.mp4' autoPlay={true} muted={true} controls={true}></video>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ImportantNews;